<template>
  <div class="open-app-component"
       @click="linkApp"
  >
    <slot></slot>
  </div>
</template>

<script>
  import { openDownloadAppMiddleware } from '@/utils/app-route';

  export default {
    name: 'OpenApp',
    data() {
      return {
        schemeUrl: '',
      };
    },
    props: {
      audioId: Number,
      name: String,
      targetType: {
        type: String,
        default: '',
      },
    },
    methods: {
      linkApp() {
        const query = {
          name: this.name,
          id: this.audioId,
          type: this.targetType,
        };
        // 打开下载App 作为中间页，进行App 跳转
        openDownloadAppMiddleware(query);
      },
    },
  };
</script>
